import { render, staticRenderFns } from "./formularioDocente.vue?vue&type=template&id=3912f3f5"
import script from "./formularioDocente.vue?vue&type=script&lang=js"
export * from "./formularioDocente.vue?vue&type=script&lang=js"
import style0 from "./formularioDocente.vue?vue&type=style&index=0&id=3912f3f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports